<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import {useI18n} from 'vue-i18n';
  import CpNuxtLink from '~/components/cp/CpNuxtLink/CpNuxtLink.vue';
  import CpText from '~/components/cp/CpText/CpText.vue';

  defineProps<{
    brandName: string
    image: string
    link: string
  }>();

  const emits = defineEmits<{
    (e: 'click'): void
  }>();

  const {b, e} = useCpBem('cp-section-pdp-row-brand-store');
  const {t} = useI18n();
  </script>

<template>
    <CpNuxtLink :class="b" :link="link" @click="emits('click')">
        <v-img :class="e('image')" :src="image" :alt="brandName" />
        <CpText :class="e('text')" variant="caption-bold" type="primary">
            {{ t('label') }} {{ brandName }}
        </CpText>
    </CpNuxtLink>
</template>

<style scoped lang="scss">
.cp-section-pdp-row-brand-store {
  display: flex;
  padding: var(--cp-gutter);
  gap: var(--cp-gutter-small);
  border-bottom: 1px solid var(--color-neutral-extra-light);
  align-items: center;
  height: 48px;
  cursor: pointer;

  &__image {
    width: 64px;
    max-width: 64px;
    min-height: 21.33px;
  }

  &__text {
    flex: 1;
  }
}
</style>

<i18n locale="es-US" lang="yaml">
  label: 'Descubre más productos de '
</i18n>
